import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionId, ThemeContext, useAuthProvider, callApi, Record } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDSelect from "@cloudpremise/portal_core/src/themes/mui/components/MDSelect";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";


const InternalApi = (props) => {
    const [ authorized, authType ] = useAuthProvider();
    const navigate = useNavigate();
    let defaultState = {
        url: window.location.origin+"/apexremote/v1/sobject",
        method: "GET",
        methodSelection: [{id: 'get', label: 'GET'}],
        queryParams: [],
        headers: [],
        body: [],
        rawData: "",
        response: "",
        errorMessage: null,
        currentTab: 0,
        activeBodyTab: 0,
        urlEditMode: false,
        statusCode: null,
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    React.useEffect(() => {
        if(authorized && (authType !== "salesforce")){
            return navigate("/auth-not-supported", { replace: true });
        }
    });
    const methods = [
        {
            'id': 'get',
            'label': 'GET'
        },
        {
            'id': 'post',
            'label': 'POST'
        },
        {
            'id': 'delete',
            'label': 'DELETE'
        },
        {
            'id': 'patch',
            'label': 'PATCH'
        }
    ];
    function handleUrlChange(event, name){
        const valueArray = event.target.value.split("?");
        let queryParams = [];
        if(valueArray.hasOwnProperty(1)){
            let paramsArray = valueArray[1].split("&");
            for(let i = 0; i < paramsArray.length; i++){
                let param = paramsArray[i];
                const paramArray = param.split("=");
                const key = paramArray[0];
                let value = "";
                if(paramArray.hasOwnProperty(1)){
                    value = paramArray[1];
                }
                queryParams[i] = {
                    key: key,
                    value: value
                }
            }
        }
        setState({
            urlEditMode: true,
            [name]: event.target.value,
            queryParams: queryParams
        });
    }
    function onSelectChange(newValue, name){
        setState({
            [name]: (newValue ? newValue.label : 'GET')
        });
    }
    function prepareRouteUrl(){
        let url = state.url;
        if(!state.urlEditMode){
            url = url.split("?")[0];
            url += prepareQueryString();
        }
        return url;
    }
    function prepareQueryString(){
        const { queryParams } = state;
        let queryString = "";
        if(queryParams.length > 0){
            queryString += "?";
        }
        for(let i = 0; i < queryParams.length; i++){
            if(i > 0){
                queryString += "&";
            }
            queryString += queryParams[i]['key'];
            if(queryParams[i]['value'].length > 0){
                queryString += "="+queryParams[i]['value'];
            }
        }
        return queryString;
    }
    function handleInputChange(dataKey, event, name, key){
        const data = state[dataKey];
        let param = {
            key: "",
            value: ""
        };
        if(data.hasOwnProperty(key)){
            param = data[key];
        }
        data[key] = {
            ...param,
            [name]: event.target.value
        }
        setState({
            urlEditMode: false,
            [dataKey]: data
        });
    }
    function handleInputRemove(dataKey, key){
        const data = state[dataKey];
        let newData = [];
        for(let i = 0; i <= data.length; i++){
            if(i === key || !data.hasOwnProperty(i)){
                continue;
            }
            newData.push(data[i]);
        }
        setState({
            urlEditMode: false,
            [dataKey]: newData
        });
    }
    function handleChange(event, name){
        setState({
            [name]: event.target.value
        });
    }
    function renderInputs(dataKey){
        const data = state[dataKey];
        const html = [];
        for(let i = 0; i <= data.length; i++){
            let inputValue = {
                key: "",
                value: ""
            };
            if(data.hasOwnProperty(i)){
                inputValue = data[i];
            }
            html.push((
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={6} md={6} lg={6}>
                        <MDBox mr={2} mt={(i > 0 ? 2 : 0)}>
                            <MDInput 
                                label={i === 0 ? "Key" : null}
                                onChange={(event) => handleInputChange(dataKey, event, "key", i)}
                                value={inputValue.key}
                                sx={{width: "100%"}}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                        <MDBox mt={(i > 0 ? 2 : 0)}>
                            <MDInput 
                                label={i === 0 ? "Value" : null}
                                onChange={(event) => handleInputChange(dataKey, event, "value", i)}
                                value={inputValue.value}
                                sx={{width: "100%"}}
                                InputProps={{
                                    endAdornment: (
                                        i !== data.length ?
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="clear inputs"
                                                    onClick={() => handleInputRemove(dataKey, i)}
                                                    edge="end"
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        :
                                        null
                                    )
                                }}
                            />
                        </MDBox>
                    </Grid>
                </Grid>
            ));
        }
        return html;
    }
    function prepareData(dataObj){
        let data = {};
        for(let i = 0; i < dataObj.length; i++){
            const key = dataObj[i]['key'];
            const value = dataObj[i]['value'];
            if(value.length > 0){
                data[key] = value;
            }
        }
        return data;
    }
    function sendRemoteRequest(){
        const { body, queryParams, headers, activeBodyTab, rawData } = state;
        let data = prepareData(body);
        if(activeBodyTab === 1){
            if(rawData.length > 0){
                try{
                    data = JSON.parse(rawData);
                }catch(e){ console.log(e); }
            }else{
                data = {};
            }
        }
        const params = prepareData(queryParams);
        const headersObj = prepareData(headers);
        let method = state.method;
        let url = window.location.origin+"/apexremote";
        let route = state.url.split("?")[0];
        route = route.replace(url, "");

        const record: Record = {
            sObjectTypeName: '',
            url: route,
            method: method,
            params: params,
            headers: headersObj,
            data: data
        };

        callApi('apexadapter', record).then((data: any) => {
            const response = JSON.stringify(data, null, '\t');
            const statusCode = data.statusCode;
            setState({
                response: response,
                statusCode: statusCode
            });
        }).catch((err) => {
            const response = JSON.stringify(err, null, '\t');
            let statusCode = 500;
            if(typeof(err) === "object" && err.hasOwnProperty("statusCode")){
                statusCode = err.statusCode;
            }
            setState({
                response: response,
                statusCode: statusCode
            });
        });
        setState({
            loading: true
        });
    }
    function onTabChange(tab){
        setState({
            currentTab: parseInt(tab)
        });
    }
    function onBodyTabChange(tab){
        setState({
            activeBodyTab: parseInt(tab)
        });
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={3} md={2} lg={2}>
                        <MDBox mr={2}>
                            <MDSelect
                                defaultValue="GET"
                                options={methods}
                                label="Method"
                                onChange={(event: any, newValue) => onSelectChange(newValue, 'method')}
                                disableClearable
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={6} md={8} lg={8}>
                        <MDBox mr={2}>
                            <MDInput 
                                label="Route"
                                onChange={(event) => handleUrlChange(event, "url")}
                                value={prepareRouteUrl()}
                                sx={{width: "100%"}}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item xs={3} md={2} lg={2}>
                        <MDBox>
                            <MDButton variant="gradient" onClick={() => sendRemoteRequest()} color="info">
                                Send
                            </MDButton>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={12} md={8} lg={6}>
                        <Tabs
                            orientation="horizontal"
                            value={state.currentTab}
                            onChange={(event, tab) => onTabChange(tab)}
                        >
                            <Tab
                                label="Params"
                            />
                            <Tab
                                label="Headers"
                            />
                            {
                                state.method !== 'GET' ?
                                    <Tab
                                        label="Body"
                                    />
                                :
                                null
                            }
                        </Tabs>
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox my={3}>
                {
                    state.currentTab === 0 ?
                        renderInputs('queryParams')
                    :
                        null
                }
                {
                    state.currentTab === 1 ?
                        renderInputs('headers')
                    :
                        null
                }
                {
                    state.currentTab === 2 ?
                        <Grid container justifyContent="flex-start" alignItems="flex-start">
                            <Grid item xs={6} md={4} lg={4}>
                                <Tabs
                                    orientation="horizontal"
                                    value={state.activeBodyTab}
                                    onChange={(event, tab) => onBodyTabChange(tab)}
                                >
                                    <Tab
                                        label="x-www-form-urlencoded"
                                    />
                                    <Tab
                                        label="raw"
                                    />
                                </Tabs>
                            </Grid>
                        </Grid>
                    :
                        null
                }
            </MDBox>
            {
                state.currentTab === 2 ?
                    <MDBox my={3}>
                        {
                            state.activeBodyTab === 0 ?
                                renderInputs('body')
                            :
                                null
                        }
                        {
                            state.activeBodyTab === 1 ?
                                <MDInput
                                    label="Raw"
                                    onChange={(event) => handleChange(event, "rawData")}
                                    value={state.rawData}
                                    sx={{width: "100%"}}
                                    multiline
                                    rows={4}
                                />
                            :
                                null
                        }
                    </MDBox>
                :
                null
            }
            <MDBox my={3}>
                <MDInput
                    label={(
                        state.statusCode ?
                            <>
                                Response (
                                    <span>Status: {state.statusCode}</span>
                                )
                            </>
                        :
                            "Response"
                    )}
                    value={state.response}
                    sx={{width: "100%"}}
                    multiline
                    rows={15}
                    readOnly
                />
            </MDBox>
        </DashboardLayout>
    )
}

export default InternalApi;